import { render, staticRenderFns } from "./manualReminderComponent.vue?vue&type=template&id=f4d2f65c"
import script from "./manualReminderComponent.vue?vue&type=script&lang=js"
export * from "./manualReminderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports